<template>
    <div class="fw-odfx">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <van-tabs v-model="active" @click="checkedTab">
            <van-tab title="未结算订单"></van-tab>
            <van-tab title="已结算订单"></van-tab>
            <div class="xiantiao"></div>
        </van-tabs>
        <WjsTab
          v-if="active == 0"
          ref="wjstab"
          @setActive="checkedTab"
        />
        <YjsTab
          v-if="active == 1"
          ref="yjstab"
        />
    </div>
</template>

<script>
    import {getCookie} from "../../../utils/auth";
    import WjsTab from "./wjsTab";
    import YjsTab from "./yjsTab";

    export default {
        components: {
            WjsTab,
            YjsTab,
        },
        data() {
            return {
                title: '订单管理',
                fwUser: {},
                deptId: '',
                token: '',
                userType: '',

                active: 0,

            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.userType = this.fwUser.userType
        },
        methods: {
            checkedTab(val) {
                this.active = val
            },
            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-odfx {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 46px;
        padding-bottom: 49px;
        background-color: #F2F1F6;
    }

    .xiantiao {
        border-bottom: #CAC6C7 solid 1px;
        height: 1px;
    }
</style>